import { CountableAggregationTypes } from '../constants';
import { FavouriteDataAdapter } from '../../favourite/common/favourite-data-adapter';
import { FavouriteDataColumn } from '../../favourite/common/favourite-interfaces';

export const shouldDisplayTotal = (dataAdapter: FavouriteDataAdapter, columns: FavouriteDataColumn[], report: number) => {
  const { uomColIndex, aggrColIndex } = dataAdapter;

  const aggrType = columns[aggrColIndex].aggregationType;
  return uomColIndex < 0 && (report !== 10) && CountableAggregationTypes.some(type => type === aggrType);
};
